import Avo from 'analytics/Avo';
import { useConfig } from 'context/app-config';
import React from 'react';
import { Button, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCustomer } from 'redux-stores/slices/authSlice';
import styled from 'styled-components';

const DownloadAppBanner: React.FC = () => {
  const { t } = useTranslation();
  const config = useConfig();
  const customer = useSelector(selectCustomer);

  if (!config || !config.showHomeDownloadAppBanner || !customer || (customer.activeOrdersCount === 0 && customer.completedOrdersCount === 0)) {
    return null;
  }

  const handleDownloadAppRedirect = () => {
    window.open('https://m.washmen.com', '_blank');
    Avo.downloadAppBannerClicked();
  };
  const StyledButton = styled(Button)`
    background: ${({ theme }) => theme.components.downloadAppBanner?.button.bgColor};
    border: ${({ theme }) => theme.components.downloadAppBanner?.button.border};
    color: ${({ theme }) => theme.components.downloadAppBanner?.button.textColor};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    border-radius: 100px;
  `;
  const StyledBannerContainer = styled.div`
    display: flex;
    align-items: center;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 12px;
    padding-bottom: 12px;
    border-radius: 8px;
    margin-bottom: 24px;
    background: ${({ theme }) => theme.components.downloadAppBanner?.bgColor};
    border: ${({ theme }) => theme.components.downloadAppBanner?.border};
    color: ${({ theme }) => theme.components.downloadAppBanner?.textColor};
  `;
  const StyledDescription = styled.h2`
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0.4px;
    margin: 0px;
  `;
  return (
    <StyledBannerContainer>
      <Col xs className="padding-end-3 padding-start-0">
        <StyledDescription>{t('homePage.downloadAppBanner.description')}</StyledDescription>
      </Col>
      <Col xs="auto" className="padding-start-0 padding-end-0">
        <StyledButton size="sm" variant="primary" onClick={handleDownloadAppRedirect}>
          {t('homePage.downloadAppBanner.downloadButton')}
        </StyledButton>
      </Col>
    </StyledBannerContainer>
  );
};

export default DownloadAppBanner;
